<template>
    <div>
        <button>
            <div>
                <slot />
            </div>
        </button>
    </div>
</template>

<script>
export default {
    props: {
        text: {
            type: String,
            default: "Button"
        }
    },
    data() {
        return {};
    }
};
</script>

<style lang="scss" scoped>
button {
    position: relative;
    border: 3px solid transparent;
    border-radius: 6px;
    padding: 10px 20px;
    font-family: Inter;
    font-size: 17px;
    font-style: normal;
    font-weight: 700;
    line-height: 27px;
    letter-spacing: 0px;
    text-align: center;
    text-transform: capitalize;
    color: #ffffff;
    background: linear-gradient(
        95.12deg,
        #1cc8c1 0%,
        #05feb1 0.01%,
        #d9ef46 28.64%,
        #ff843f 49.48%,
        #a2f9e4 73.96%,
        #05feb1 100%
    );
    box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
    cursor: pointer;
    z-index: 1;
    background-size: 300%;
    background-position: -100%;
    animation: animatedText 5s infinite alternate-reverse;
    transition: all ease 0.3s;

    > div:first-child {
        background-image: linear-gradient(
            95.12deg,
            #1cc8c1 0%,
            #05feb1 0.01%,
            #d9ef46 28.64%,
            #ff843f 49.48%,
            #a2f9e4 73.96%,
            #05feb1 100%
        );
        -webkit-background-clip: text;
        background-clip: text;
        color: transparent;

        background-size: 300%;
        background-position: -100%;

        animation: animatedText 5s infinite alternate-reverse;
    }

    &:before {
        content: "";
        background: #172120;
        position: absolute;
        top: 0px;
        left: 0px;
        bottom: 0px;
        right: 0px;
        z-index: -1;
        border-radius: 6px;

        @media only screen and (min-width: 1440px) {
            border-radius: 6px;
        }
    }

    &:hover {
        background: linear-gradient(
            90.79deg,
            #1fffab 4.94%,
            #1abb7e 24.74%,
            #1fffab 46.27%,
            #1ecb8a 63.92%,
            #12cc86 87.6%
        );
        transform: scale(1.1);
    }

    /* @media only screen and (min-width: 1440px) {
        border: 0.20833333333333334vw solid transparent;
        border-radius: 0.4166666666666667vw;
        padding: 0.6944444444444444vw 1.3888888888888888vw;
        font-size: 1.1805555555555556vw;
        line-height: 1.875vw;
        box-shadow: 0px 0.2777777777777778vw 0.2777777777777778vw
            rgba(0, 0, 0, 0.25);
    } */
}

@keyframes animatedText {
    to {
        background-position: 100%;
    }
}
</style>
